export interface Display {
  isToggleOn: boolean;
}

export enum termType {
  None = '',
  Start = 'start',
  End = 'end',
}
